import { render, staticRenderFns } from "./PaymentsList.vue?vue&type=template&id=3a05584f&scoped=true&"
import script from "./PaymentsList.vue?vue&type=script&lang=js&"
export * from "./PaymentsList.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsList.vue?vue&type=style&index=0&id=3a05584f&lang=scss&scoped=true&"
import style1 from "./PaymentsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a05584f",
  null
  
)

export default component.exports